import styled from "styled-components";

export default styled.div`
  padding: 31px 10px;
  ${(props) => props.theme.media.md} {
    padding: 98px 62px 50px 62px;
  }
  .image-wrapper {
    margin-bottom: 30px;
  }

  .text-container {
    .title {
      font-size: 36px;
      font-weight: 600;
      max-width: 400px;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 0px;
      padding: 0 2rem;
      ${(props) => props.theme.media.lg} {
        padding: 0;
      }
    }
    .features {
      padding: 25px;
      ${(props) => props.theme.media.lg} {
        padding: 35px;
      }
      .feature-item {
        margin: auto;
        max-width: 368px;
        h3 {
          position: relative;
          font-size: 18px;
          display: flex;
          ${(props) => props.theme.media.lg} {
            display: block;
            font-size: 24px;
          }
          font-weight: 500;
          margin-bottom: 0;
          margin-right: 0px;
          line-height: 20px;
          text-align: left;
          ${(props) => props.theme.media.lg} {
            text-align: center;
            margin-right: 80px;
          }
          ${(props) => props.theme.media.sm} {
            padding-left: 40px;
            text-align: left;
          }

          .check-icon {
            display: block;
            width: 100%;
            max-width: 24px;
            margin-top: -6px;
            margin-right: 10px;
            ${(props) => props.theme.media.lg} {
              margin-top: 0px;
              margin-right: 0px;
            }
            ${(props) => props.theme.media.sm} {
              left: 0px;
              top: -5px;
              width: auto;
              position: absolute;
            }
          }
        }

        p {
          font-size: 16px;
          text-align: center;
        }
      }
    }
    .description2 {
      p {
        text-align: center;
        font-size: 16px;
        padding: 0 10px;
        line-height: 24px;
      }
    }
    .ctaContainer {
      display: flex;
      justify-content: center;
    }
  }

  ${(props) => props.theme.media.lg} {
    display: flex;

    .image-wrapper {
      margin-right: 100px;
      display: block;
      margin-bottom: 0px;
    }

    .text-container {
      .title {
        font-size: 36px;
        text-align: left;
        margin-left: 10px;
        font-weight: 600;
        margin-bottom: 20px;
        line-height: 1.1;
        max-width: none;
      }
      .features {
        .feature-item {
          max-width: none;

          h3 {
            font-size: 20px;
          }
          p {
            text-align: left;
            padding-left: calc(0.5rem + 31px);
          }
        }
      }
      .description2 {
        p {
          text-align: center;
          margin-right: 65px;
          font-size: 18px;
          line-height: 24px;
        }
      }

      .ctaContainer {
        display: flex;
        justify-content: center;
        margin-right: 85px;
      }
    }
  }
  //////
  .tooltip-inline {
    display: inline-block;
    font-size: 18px;
    height: 18px;
    position: relative;

    width: 18px;

    left: 3px;
    right: 2px;
    .tooltip-i {
      color: #3e5261;
      font-weight: bold;
      font-size: 14px;
      line-height: 20px;
      width: 20px;
      height: 20px;
      background: #ece5d8;
      border-radius: 50%;
      padding-left: 0px;
      cursor: pointer;
      ${(props) => props.theme.media.lg} {
        padding-left: 8px;
      }
    }
    .tooltip-text-inline {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      background-color: #ece5d8;
      border-radius: 7px;
      box-shadow: 0px 2px 4px rgba(2, 36, 30, 0.15);
      color: ${(props) => props.theme.textColor};
      max-width: 400px;
      padding: 1rem 1rem;
      position: absolute;
      right: -100px;
      top: 30px;
      font-family: Inter;
      width: 280px;
      ${(props) => props.theme.media.lg} {
        width: 360px;
        right: 0;
      }
      @media screen and (min-width: 1300px) {
        right: -330px;
      }
      visibility: hidden;
      z-index: 1;
      &.cc {
        right: 0;
      }
    }

    &:hover {
      .tooltip-text-inline {
        visibility: visible;
      }
    }
  }
`;
